import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"
import useFetch, { CachePolicies } from "use-http";
import RecentFileContainer from "../../RecentFile/RecentFileContainer";
import SkeletonRecentFile from "../../RecentFile/SkeletionRecentFile";
import RecentFileCard from "../../RecentFile/RecentFileCard";
import FolderContainer from "../../Folder/FolderContainer";
import SkeletonFolder from "../../Folder/SkeletionFolder";
import FolderCard from "../../Folder/FolderCard";
import FileContainer from "../../File/FileContainer";
import SkeletonFile from "../../File/SkeletionFile";
import FileCard from "../../File/FileCard";
//@ts-ignore
import _ from "lodash";
import { checkEmpty, parseJwt } from "src/service/util.service";
import * as Auth from "../../../../service/auth.service";
import { APIFileEnpoint, getFileFoldersMethodGet, } from "src/service/files.service";

import { FileContext } from "../../File.context";
import { mainState, nodataFile } from "src/props/util.props";
import { tabName } from "../../properies.file";
import InfiniteScroll from "react-infinite-scroll-component";
import styles from "./MyFileContainer.module.scss";
import { fetchNextUtil } from "src/service/files.util";
import { useTranslation } from "react-i18next";
import NoData from "src/components/shared/NoDataDisplay/NoData";

const defaultLitmitOfset = 30;
let linkFiles = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + APIFileEnpoint.getFiles;

let MyFileContainer = (props: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [offsetFile, setOffsetFile]: any = useState(0);
  const [offsetFolder, setOffsetFolde]: any = useState(0);
  const [loading, setLoading]: any = useState(false);
  const [currentRes, setCurentRes]: any = useState({});
  const fileContext: any = useContext(FileContext);

  const getFileRecentData = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + APIFileEnpoint.getFiles,
    {
      // path: APIEnpoint.myApps,
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  // const getFileFolderData = useFetch(linkFiles, {
  //   // path: APIEnpoint.myApps,
  //   cachePolicy: CachePolicies.NO_CACHE,
  // });

  const getUserData = () => {
    let token = Auth.getToken();
    let userdata: any = null;
    if (!checkEmpty(token)) {
      userdata = parseJwt(token);
    }
    return userdata;
  };

  const fetchFileRecentData = async (data: any) => {
    fileContext.setRecentFiles([]);
    if (
      fileContext.viewDir === "y" ||
      !checkEmpty(fileContext.parentFolderId)
    ) {
      return;
    }

    let ts = [];
    let files: any = data?.data;
    let ls = files?.filter((item: any) => {
      return item.type_ === "FILE";
    });
    for (let a = 0; a < ls?.length && a < 4; a++) {
      ts.push(ls[a]);
    }
    fileContext.setRecentFiles(ts);
  };

  // useEffect(() => {
  //   console.log("recentFiles : ", fileContext.recentFiles)
  // }, [fileContext.fileFolders]);

  useEffect(() => {
    setOffsetFile(0);
    if(fileContext.tab != tabName.search){
      fileContext.setFileSearchInput("");
    }
  }, [fileContext.tab]);

  useEffect(() => {
    setOffsetFile(0);
  }, [fileContext.fileSearchInput]);

  useEffect(() => {
    // console.log("isShared myfile", props.isShared);

  }, [props.isShared])

  const fetchFileFolderDataInit = async (recent: any) => {
    if (
      fileContext.clickFromGroupTab &&
      sessionStorage.getItem("group-tab-groupId") !== fileContext.groupId
    )
      return;
    sessionStorage.removeItem("group-tab-groupId");
    fileContext.setClickFromGroupTab(false);
    console.log(
      "fetchFileFolderDataInit fetchFileFolderDataInit",
      fileContext.groupId
    );
    if (offsetFile === 0) fileContext.setFileFolders([]);
    let keyword = "";
    if (!checkEmpty(fileContext.fileSearchInput)) {
      keyword = fileContext.fileSearchInput;
    }
    let param = {
      groupId: fileContext.groupId,
      userId: getUserData()?.userID,
      offset: offsetFile,
      limitOfset: defaultLitmitOfset,
      parentFolderId: fileContext.parentFolderId,
      tag: fileContext.tab,
      keyword: keyword
    };

    try {
      setLoading(true);
      let response: any = await getFileFoldersMethodGet(
        param,
        linkFiles,
        fileContext
      );
      setCurentRes(response);

      if (offsetFile === 0) {
        fileContext.setHasMore(true);
        fileContext.setLoadMore(false);
      }
      if (!checkEmpty(response?.data)) {
        fileContext.setFileFolders(response?.data?.data);
        if (response?.data?.total === 0) {
          fileContext.setHasMore(false);
        }
        if (
          fileContext.fileFolders?.length + defaultLitmitOfset >=
          response?.data?.total
        ) {
          fileContext.setHasMore(false);
        }
      } else {
        fileContext.setFileFolders([]);
      }
      fetchFileRecentData(response?.data);
    } catch (e) {
      console.error(e);
      // setLoading(false);
    }
    setLoading(false);
  };

  const fetchFileFolderData = async () => {
    if (offsetFile === 0) fileContext.setFileFolders([]);
    let keyword = "";
    if (!checkEmpty(fileContext.fileSearchInput)) {
      keyword = fileContext.fileSearchInput;
    }
    let param = {
      groupId: fileContext.groupId,
      userId: getUserData()?.userID,
      offset: offsetFile,
      limitOfset: defaultLitmitOfset,
      parentFolderId: fileContext.parentFolderId,
      tag: fileContext.tab,
      keyword: keyword
    };

    try {
      setLoading(true);
      let response: any = await getFileFoldersMethodGet(
        param,
        linkFiles,
        fileContext
      );
      setCurentRes(response);
      // setLoading(false);

      if (offsetFile === 0) {
        fileContext.setHasMore(true);
        fileContext.setLoadMore(false);
      }
      fileContext.setFileFolders((prev: any) => {
        if (offsetFile === 0) return response?.data?.data;
        if (checkEmpty(prev)) prev = [];
        return [...prev, ...response?.data?.data];
      });
      if (response?.data?.total === 0) {
        fileContext.setHasMore(false);
      }
      if (
        fileContext.fileFolders?.length + defaultLitmitOfset >=
        response?.data?.total
      ) {
        fileContext.setHasMore(false);
      }
    } catch (e) {
      console.error(e);
      // setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (fileContext.groupId !== mainState.init) {
      fetchFileFolderData();
    }
  }, [
    // fileContext.groupId,
    offsetFile,
    // fileContext.parentFolderId,
    // fileContext.tab,
  ]);

  useEffect(() => {
    console.log("fileContext.parentFolderId : ", fileContext.parentFolderId);

    if (
      !checkEmpty(fileContext.parentFolderId) ||
      !checkEmpty(fileContext.tab)
    ) {
      // fileContext.setRecentFiles([]);
      if (fileContext.groupId !== mainState.init) fetchFileFolderDataInit(true);
    } else {
      if (fileContext.groupId !== mainState.init) fetchFileFolderDataInit(true);
      // fetchFileRecentData();
    }
  }, [
    fileContext.groupId,
    // offsetFile,
    fileContext.parentFolderId,
    fileContext.tab,
    fileContext.fileSearchInput,
  ]);

  useEffect(() => {

  }, [fileContext.recentFiles])

  useEffect(() => {
    setOffsetFile(0);
  }, [fileContext.groupId, fileContext.parentFolderId]);

  const getFileFolder = (type: string) => {
    let ls = fileContext?.fileFolders?.filter((item: any) => {
      return item.type_ === type;
    });
    if (checkEmpty(ls)) ls = [];
    return ls;
  };

  /*
  useEffect(() => {
    if (
      fileContext.tab === tabName.sharedWithMe &&
      checkEmpty(fileContext?.currentSharedWith?.file_app_id)
    ) {
      fileContext.setFiles(getFileData.response?.data?.data);
      return;
    }
    if (fileContext.groupId !== mainState.init) fetchFileData();
  }, [
    fileContext.groupId,
    offsetFile,
    fileContext.parentFolderId,
    fileContext.viewDir,
  ]);
  */

  // useEffect(() => {
  //   if (
  //     fileContext.tab === tabName.sharedWithMe &&
  //     checkEmpty(fileContext?.currentSharedWith?.file_app_id)
  //   ) {
  //     fileContext.setFolders(getFileData.response?.data?.data);
  //     return;
  //   }
  //   if (fileContext.groupId !== mainState.init) fetchFoldersData();
  // }, [
  //   fileContext.groupId,
  //   offsetFolder,
  //   fileContext.parentFolderId,
  //   fileContext.viewDir,
  // ]);

  useEffect(() => {
    if (
      fileContext.tab === tabName.sharedWithMe &&
      checkEmpty(fileContext?.currentSharedWith?.file_app_id)
    ) {
      fileContext.setRecentFiles([]);
      return;
    }

    // fetchFileRecentData();
  }, []);

  const fetchNext = async () => {
    console.log("fetchNext fetchNext");
    fetchNextUtil(
      fileContext,
      currentRes?.data,
      setOffsetFile,
      defaultLitmitOfset,
      offsetFile
    );
  };

  return (
    <>
      <InfiniteScroll
        dataLength={
          fileContext.fileFolders !== null ? fileContext.fileFolders?.length : 0
          // 100
        }
        next={fetchNext}
        hasMore={fileContext.hasMore}
        scrollableTarget={"FileFoldersContainer"}
        loader={!fileContext.hasMore ? null : <SkeletonFile />}
        className={styles.customInfinitscroll}
        style={{ overflow: "none !important" }}
      >
        {checkEmpty(fileContext.parentFolderId) &&
          fileContext.recentFiles?.length > 0 &&
          !(
            fileContext.tab === tabName.mediavideo ||
            fileContext.tab === tabName.mediaimage ||
            fileContext.tab === tabName.other ||
            fileContext.tab === tabName.doc ||
            fileContext.tab === tabName.unknow ||
            fileContext.tab === tabName.trash ||
            fileContext.tab === tabName.search
          ) && fileContext.showRecentFiles === true &&
          (
            <RecentFileContainer header={t("Recent Files")}>
              {getFileRecentData.loading ? (
                <SkeletonRecentFile />
              ) : (
                fileContext.recentFiles?.map((recentFile: any, idx: number) => {
                  return (
                    <RecentFileCard
                      key={recentFile?.file_app_id}
                      file={recentFile}
                    />
                  );
                })
              )}
            </RecentFileContainer>
          )}

        {fileContext.viewDir !== "y" && (
          <>
            {!loading ? (
              getFileFolder("DIRECTORY").length || getFileFolder("FILE").length > 0 ? (
                <>
                  {(checkEmpty(fileContext.tab) ||
                    !(
                      fileContext.tab === tabName.mediavideo ||
                      fileContext.tab === tabName.mediaimage ||
                      fileContext.tab === tabName.other ||
                      fileContext.tab === tabName.doc ||
                      fileContext.tab === tabName.unknow ||
                      fileContext.tab === tabName.search
                    )) && (
                      <>
                        <FolderContainer
                          header={t("Folders")}
                          tableHeader={
                            getFileFolder("DIRECTORY").length !== 0 ? true : false
                          }
                        >
                          {loading && !fileContext.loadMore ? (
                            <SkeletonFolder />
                          ) : (
                            //@ts-ignore
                            getFileFolder("DIRECTORY")?.map((file, idx) => {
                              return <FolderCard file={file} key={file.file_app_id} isShared={props.isShared} />;
                            })
                          )}
                        </FolderContainer>
                      </>
                    )}
                  <FileContainer
                    header={t("Files")}
                    tableHeader={getFileFolder("FILE").length !== 0 ? true : false}
                  >
                    {loading && !fileContext.loadMore ? (
                      <SkeletonFile />
                    ) : (
                      //@ts-ignore
                      getFileFolder("FILE")?.map((file, idx) => {
                        return <FileCard file={file} key={file.file_app_id} isShared={props.isShared} />;
                      })
                    )}
                  </FileContainer>
                </>

              ) : (
                <NoData
                  header={t(nodataFile.noDataHeaderFileText)}
                  detail={
                    t(nodataFile.nodataFiletextH) +
                    ", " +
                    t(nodataFile.nodataFiletextL) +
                    "."
                  }
                />
              )
            ) : (
              <SkeletonFile />
            )
            }
          </>
        )}

        {/* {fileContext.viewDir === "y" && (
          <>
            <FolderContainer header={t("Folders")}>
              {loading ? (
                <SkeletonFolder />
              ) : (
                //@ts-ignore
                getFileFolder("DIRECTORY")?.map((file, idx) => {
                  return <FolderCard file={file} key={file.file_app_id} />;
                })
              )}
            </FolderContainer>
            {!loading && getFileFolder("DIRECTORY").length === 0 && (
              <div className={styles.textEmpty}>{t("Empty")}</div>
            )}
          </>
        )} */}
      </InfiniteScroll>
    </>
  );
};

export default MyFileContainer;
